import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';  // ✅ Cambio aquí

export const generateSalePDF = (sale, openInNewTab = false) => {
    // Validación: verificar que la venta tenga items
    if (!sale || !sale.items || !Array.isArray(sale.items) || sale.items.length === 0) {
        alert('Error: No se puede generar el PDF. La venta no tiene items.');
        console.error('Sale data:', sale);
        return;
    }

    const doc = new jsPDF();

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const businessInfo = {
        name: user?.business_name || 'Comprobante de Venta',
        ruc: '10123456789',
        address: user?.address || 'Calle Las Flores 123',
        phone: user?.phone || '987 654 321',
        email: user?.email || ''
    };

    // Encabezado
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text(businessInfo.name, 105, 20, { align: 'center' });
    
    // Línea separadora
    doc.setDrawColor(200);
    doc.line(20, 28, 190, 28);

    // Información de la venta
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`COMPROBANTE DE VENTA #${sale.id}`, 105, 38, { align: 'center' });

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Fecha: ${new Date(sale.created_at || sale.sale_date).toLocaleString()}`, 20, 48);
    doc.text(`Cliente: ${sale.customer_name || 'Cliente General'}`, 20, 54);
    
    const paymentMap = {
        'efectivo': 'Efectivo',
        'tarjeta': 'Tarjeta',
        'transferencia': 'Transferencia',
        'yape': 'Yape/Plin',
        'fiado': 'Fiado (Por Cobrar)'
    };
    const paymentText = paymentMap[sale.payment_method] || (sale.payment_method ? sale.payment_method.toUpperCase() : 'No especificado');
    
    doc.text(`Pago: ${paymentText}`, 20, 60);
    
    if (sale.order_reference) {
        doc.text(`N° Pedido: ${sale.order_reference}`, 20, 66);
    }

    // Tabla de productos
    const tableData = sale.items.map(item => [
        item.product_name,
        item.unit === 'kg' ? parseFloat(item.quantity) : String(parseInt(item.quantity)),
        `S/. ${parseFloat(item.unit_price).toFixed(2)}`,
        `S/. ${parseFloat(item.total_price).toFixed(2)}`
    ]);

    autoTable(doc, {  // ✅ Cambio aquí: autoTable(doc, { ... })
        startY: sale.order_reference ? 72 : 66,
        head: [['Producto', 'Cantidad', 'P. Unitario', 'Total']],
        body: tableData,
        theme: 'striped',
        headStyles: { fillColor: [66, 139, 202] },
        styles: { fontSize: 10 },
        columnStyles: {
            0: { cellWidth: 90 },
            1: { cellWidth: 30, halign: 'center' },
            2: { cellWidth: 35, halign: 'right' },
            3: { cellWidth: 35, halign: 'right' }
        }
    });

    // Totales
    const finalY = doc.lastAutoTable.finalY + 10;
    
    if (sale.subtotal && sale.discount_amount > 0) {
        doc.text(`Subtotal:`, 140, finalY);
        doc.text(`S/. ${parseFloat(sale.subtotal).toFixed(2)}`, 190, finalY, { align: 'right' });
        
        doc.text(`Descuento:`, 140, finalY + 6);
        doc.text(`-S/. ${parseFloat(sale.discount_amount).toFixed(2)}`, 190, finalY + 6, { align: 'right' });
    }

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    const totalY = sale.subtotal && sale.discount_amount > 0 ? finalY + 12 : finalY;
    doc.text(`TOTAL:`, 140, totalY);
    doc.text(`S/. ${parseFloat(sale.total || sale.total_amount).toFixed(2)}`, 190, totalY, { align: 'right' });

    // Pie de página
    doc.setFontSize(9);
    doc.setFont('helvetica', 'italic');
    doc.text('¡Gracias por su compra!', 105, 280, { align: 'center' });

    // Opción de Ver o Descargar
    if (openInNewTab) {
        window.open(doc.output('bloburl'), '_blank');
    } else {
        doc.save(`venta-${sale.id}.pdf`);
    }
};

export default { generateSalePDF };